import { render } from "./UserLabelDetailPage.vue?vue&type=template&id=44839551&ts=true"
import script from "./UserLabelDetailPage.vue?vue&type=script&lang=ts&setup=true"
export * from "./UserLabelDetailPage.vue?vue&type=script&lang=ts&setup=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/pages/user-label/UserLabelDetailPage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "44839551"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('44839551', __exports__)) {
    api.reload('44839551', __exports__)
  }
  
  module.hot.accept("./UserLabelDetailPage.vue?vue&type=template&id=44839551&ts=true", () => {
    api.rerender('44839551', render)
  })

}


export default __exports__